import React, { useState } from "react";
import {
    Card,
    CardContent,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography,
    CardActions,
    Button,
    Box,
    Grid,
    Stack,
    Chip,
    IconButton,
    Collapse,
    TableContainer,
    Paper,
} from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Groups2Icon from '@mui/icons-material/Groups2';
import PersonIcon from '@mui/icons-material/Person';
import HistoryIcon from '@mui/icons-material/History';
import ShareIcon from '@mui/icons-material/Share';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import EditIcon from '@mui/icons-material/Edit';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import EuroIcon from '@mui/icons-material/Euro';
import { EventoComidaDialog } from "../calendario/EventoComidaDialog";
import { getDatosContables, postBloquear } from "../../services/apis";
import { useEffect } from "react";
import { FormAsistirComida } from "./FormAsistirComida";
import { AnadirGastoDialog } from "../contabilidad/AnadirGasto.Dialog";
import { RegistroAccionesComidaDialog } from "../calendario/RegistroAccionesComidaDialog";
import { InvitacionActividad } from "../calendario/InvitacionActividad";
import { formatoHorarioEvento, getResumenCategoriasTickets, getResumenPreciosEvento, getTextoEncargadosEvento } from "../eventos/eventosUtils";
import { borrarTokenSesion } from "../../utils/cookies";

const invitadosValor = (invitados, clave) => {
    return invitados?.[clave] || invitados?.[clave.replace("nino", "niño")] || invitados?.[clave.replace("nino", "niÃ±o")] || 0;
};

export const ComidaCard = ({ data, totalAsistentes, opTrabajadores, setSuccesCrearComida }) => {
    const resumenPrecio = getResumenPreciosEvento(data);
    const resumenCategorias = getResumenCategoriasTickets(data);
    const totalMiembros = data.asistentes.reduce((total, asistente) => (
        total + (Number(asistente.miembro_asiste ?? 1) === 1 ? 1 : 0)
    ), 0);
    const totalInvitadosPenya = Number(data.invitados_penya || 0);
    const totalConInvitadosPenya = Number(totalAsistentes || 0) + totalInvitadosPenya;
    const tiposTicketsResumen = data.tipos_tickets || [];
    const cantidadTipoTicket = (asistente, idTipo) => Number((asistente.tickets || []).find((ticket) => Number(ticket.id_tipo_ticket) === Number(idTipo))?.cantidad || 0);

    const responsable = getTextoEncargadosEvento(data, opTrabajadores);
    const [desplegar, setDesplegar] = useState(false);
    const [editar, setEditar] = useState(false);
    const [asistir, setAsistir] = useState(false);
    const [modalAnadirGastoOpen, setModalAnadirGastoOpen] = useState(false);
    const [anioSeleccionado] = useState(new Date().getFullYear());
    const [currenApartado] = useState(data.id_apartado || null);
    const [bloqueado, setBloqueado] = useState(data.cerrado || 0);
    const [dialogRegistros, setDialogRegistros] = useState(false);
    const [invitar, setInvitar] = useState(false);
    const [contadorError, setContadorError] = useState(0);

    const handleAdd = () => {
        setModalAnadirGastoOpen(false);
    };

    const cargarDatos = async () => {
        try {
            await getDatosContables(anioSeleccionado);
        } catch (error) {
            setContadorError(prev => prev + 1);
            if (contadorError > 3) {
                localStorage.clear();
                window.location.href = "/login";
                borrarTokenSesion();
            }
        }
    };

    useEffect(() => {
        if (modalAnadirGastoOpen) {
            cargarDatos();
        }
    }, [modalAnadirGastoOpen]);

    const cerrarComida = async () => {
        const nuevoBloqueado = bloqueado === 1 ? 0 : 1;
        const datos = { id: data.id, cerrado: nuevoBloqueado };

        try {
            const response = await postBloquear(datos);
            if (response.success) {
                setSuccesCrearComida(true);
                setBloqueado(nuevoBloqueado);
            } else {
                console.error("Error en tancar el menjar:", response.error);
            }
        } catch (error) {
            console.error("Error en la sol·licitud:", error);
        }
    };

    return (
        <Card className={`meal-card ${bloqueado === 1 ? "meal-card-closed" : ""}`}>
            <CardContent className="meal-card-content">
                <Box className="meal-card-top">
                    <Box className="meal-card-icon">
                        <RestaurantMenuIcon />
                    </Box>
                    <Box className="meal-card-title-block">
                        <Typography variant="h6" className="meal-card-title" title={data.asunto || data.descripcion}>
                            {data.asunto || data.descripcion || "Menjar"}
                        </Typography>
                        <Stack direction="row" className="meal-card-meta">
                            <span><AccessTimeIcon fontSize="inherit" />{formatoHorarioEvento(data)}</span>

                        </Stack>
                    </Box>
                    <IconButton className="meal-history-button" size="small" onClick={() => setDialogRegistros(true)}>
                        <HistoryIcon fontSize="small" />
                    </IconButton>
                </Box>

                {data.descripcion && (
                    <Typography className="meal-description">
                        {data.descripcion}
                    </Typography>
                )}

                <Box className="meal-owner-row">
                    <PersonIcon fontSize="small" />
                    <Typography className="meal-owner">
                        {responsable.label}: {responsable.texto}
                    </Typography>
                    <Chip
                        size="small"
                        className={bloqueado === 1 ? "meal-status-chip meal-status-closed" : "meal-status-chip meal-status-open"}
                        label={bloqueado === 1 ? "Tancat" : "Obert"}
                    />
                </Box>

                <Grid container spacing={1} className="meal-summary-grid">
                    <Grid size={{ xs: 4 }}>
                        <Box className="meal-summary-box">
                            <Typography>{totalConInvitadosPenya}</Typography>
                            <span>TOTAL</span>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 4 }}><Box className="meal-summary-box"><Typography>{totalInvitadosPenya}</Typography><span>CONVIDAT GE.</span></Box></Grid>
                    <Grid size={{ xs: 4 }}>
                        <Box className="meal-summary-box">
                            <Typography>{totalMiembros}</Typography>
                            <span>PENYA</span>
                        </Box>
                    </Grid>
                    {resumenCategorias.map((categoria) => (
                        <Grid key={categoria.id} size={{ xs: 4 }}>
                            <Box className="meal-summary-box">
                                <Typography>{categoria.cantidad}</Typography>
                                <span>{categoria.nombre}</span>
                            </Box>
                        </Grid>
                    ))}
                </Grid>

                <Button
                    fullWidth
                    variant="outlined"
                    className="meal-toggle"
                    endIcon={desplegar ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    onClick={() => setDesplegar(!desplegar)}
                >
                    <Groups2Icon fontSize="small" />
                    {desplegar ? "Ocultar assistents" : `Veure assistents (${totalConInvitadosPenya})`}
                </Button>

                <Collapse in={desplegar} timeout="auto" unmountOnExit>
                    <TableContainer component={Paper} elevation={0} className="meal-table-wrap">
                        <Table size="small" className="meal-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Assistent</TableCell>
                                    <TableCell align="center">PENYA</TableCell>
                                    {tiposTicketsResumen.map((tipo) => <TableCell key={tipo.id} align="center">{tipo.descripcion_corta || tipo.nombre}</TableCell>)}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.asistentes.map((a) => (
                                    <TableRow key={a.id_usuario}>
                                        <TableCell>{a.nombre}</TableCell>
                                        <TableCell align="center">{Number(a.miembro_asiste ?? 1) === 1 ? 1 : 0}</TableCell>
                                        {tiposTicketsResumen.map((tipo) => <TableCell key={tipo.id} align="center">{cantidadTipoTicket(a, tipo.id)}</TableCell>)}
                                    </TableRow>
                                ))}
                                <TableRow>
                                    <TableCell><strong>CONVIDAT GE.</strong></TableCell>
                                    <TableCell align="center">0</TableCell>
                                    {tiposTicketsResumen.map((tipo, indice) => <TableCell key={tipo.id} align="center"><strong>{indice === 0 ? totalInvitadosPenya : 0}</strong></TableCell>)}
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Collapse>
            </CardContent>

            <CardActions className="meal-actions">
                <Button size="small" variant="contained" startIcon={<ShareIcon />} disabled={bloqueado === 1} onClick={() => setInvitar(true)}>
                    Convidar
                </Button>
                <Button size="small" variant="contained" startIcon={<HowToRegIcon />} disabled={bloqueado === 1} onClick={() => setAsistir(true)}>
                    Assistir
                </Button>
                <Button size="small" variant="outlined" startIcon={<EditIcon />} disabled={data.opciones !== 1 || bloqueado === 1} onClick={() => setEditar(true)}>
                    Editar
                </Button>
                <Button size="small" variant="outlined" startIcon={<ReceiptLongIcon />} disabled={bloqueado === 1} onClick={() => setModalAnadirGastoOpen(true)}>
                    Despesa
                </Button>
                <Button size="small" variant="outlined" startIcon={bloqueado === 1 ? <LockOpenIcon /> : <LockIcon />} disabled={data.opciones !== 1} onClick={cerrarComida}>
                    {bloqueado === 1 ? "Obrir" : "Tancar"}
                </Button>
            </CardActions>

            {editar && (
                <EventoComidaDialog open={editar} setOpen={setEditar} tarea={data} opTrabajadores={opTrabajadores} setSuccesCrearComida={setSuccesCrearComida} />
            )}
            {asistir && (
                <FormAsistirComida open={asistir} setOpen={setAsistir} tarea={data} opTrabajadores={opTrabajadores} modo={"asistir"} setSuccesCrearComida={setSuccesCrearComida} />
            )}
            {dialogRegistros && (
                <RegistroAccionesComidaDialog
                    open={dialogRegistros}
                    setOpen={setDialogRegistros}
                    idEvento={data}
                />
            )}
            {invitar && (
                <InvitacionActividad open={invitar} setOpen={setInvitar} data={data} />
            )}
            <AnadirGastoDialog
                open={modalAnadirGastoOpen}
                onClose={() => setModalAnadirGastoOpen(false)}
                onAdd={handleAdd}
                year={anioSeleccionado}
                cargarDatos={cargarDatos}
                currentApartado={currenApartado}
                evento={data}
            />
        </Card>
    );
};
